import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import LoginDeriv from "./pages/LoginDeriv";
import PendingApproval from "./pages/PendingApproval";
import Dashboard from "./pages/UserDashboard";
import OverUnderDashboard from "./pages/OverUnderDashboard";
import EvenOddDashboard from "./pages/EvenOddDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginDeriv />} />
        <Route path="/pending" element={<PendingApproval />} />
        <Route path="/user" element={<Dashboard />} />
        <Route path="/over-under" element={<OverUnderDashboard />} />
        <Route path="/even-odd" element={<EvenOddDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
